const Theme = {
  body_background_color: '#d2d3e5',
  header_padding: 20,
  logo_image_url: 'soeursgrisesmtl.png',
  logo_height: 140,

  token_hidden: true,
  number_hidden: true,

  button_color: '#538e94',
  button_radius: 50,
  button_border_width: 1,
}

export default Theme
